<template>
  <b-navbar :class="classes">
    <template slot="brand">
      <b-navbar-item tag="router-link" to="/home">
        <img :src="notebook" height="28">
        <span class="logo is-size-6" v-if="!isMobile">tinythoughts</span>
      </b-navbar-item>
    </template>
    <template slot="start" v-if="isAuthenticated">
      <b-navbar-item
        tag="router-link"
        to="/home"
        class="has-text-primary"
        active-class="has-text-weight-semibold">
        Timeline
      </b-navbar-item>
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'Gallery' }"
        class="has-text-primary"
        active-class="has-text-weight-semibold">
        Gallery
      </b-navbar-item>
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'Mood' }"
        class="has-text-primary"
        active-class="has-text-weight-semibold">
        Mood
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item
        class="ak-trigger has-text-primary has-text-weight-semibold is-flex"
        v-if="isAuthenticated && showWhatsNew"
      >
        <div class="whats-new">What's New?</div>
        <announce-kit
          catchClick=".ak-trigger"
          :onWidgetUnread="handleWidgetUnread"
          widget="https://announcekit.app/widget/32uKyY"
        />
      </b-navbar-item>
      <b-navbar-dropdown :label="userEmail" v-if="isAuthenticated">
        <b-navbar-item
          class="ak-trigger has-text-primary has-text-weight-semibold is-flex"
          v-if="isAuthenticated && !showWhatsNew"
        >
          <div class="whats-new">What's New?</div>
          <announce-kit
            catchClick=".ak-trigger"
            :onWidgetUnread="handleWidgetUnread"
            widget="https://announcekit.app/widget/32uKyY"
          />
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          to="/settings"
        >
          Settings
        </b-navbar-item>
        <b-navbar-item @click.native="handleSignOut">
          Log Out
        </b-navbar-item>
      </b-navbar-dropdown>
      <router-link
        to="/login"
        class="is-primary navbar-item"
        v-else>
        Sign up/Log in
      </router-link>
    </template>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AnnounceKit from 'announcekit-vue'
import notebook from '@/assets/notebook.png'

export default {
  name: 'NavMenu',
  props: ['sticky', 'isPrimary'],
  components: {
    AnnounceKit
  },
  data() {
    return {
      notebook,
      showWhatsNew: false,
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userEmail',
      'userId'
    ]),
    classes() {
      return {
        navbar: true,
        sticky: this.sticky,
        'is-primary': this.isPrimary,
      }
    },
    isMobile() {
      return this.$mq.isMobile()
    }
  },
  methods: {
    ...mapActions([
      'userSignOut'
    ]),
    handleSignOut() {
      this.userSignOut()
    },
    handleWidgetUnread({ unread }) {
      if (unread > 0 && this.isAuthenticated) {
        this.showWhatsNew = true
      } else {
        this.showWhatsNew = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.logo {
  margin-left: 5px;
}

.sticky {
  position: sticky;
  top: 0;
}

.whats-new {
  line-height: 1.7em;
  padding-right: 8px;
}
</style>
